import api from './api';

export default {
  getFoundations: (communityId, skip = 0) => api.get(`getFoundations/${communityId}?skip=${skip}`),
};
